module.exports = __webpack_public_path__ + "img/Moduuli_3_voittotavoite.f7add0b9.png";